export const hiraganaKatakanaData = [
  {
    type: "Hiragana",
    character: "あ",
    pronunciation: "",
    meaning: "Hiragana for 'a'",
    romaji: "a",
    strokes: 3,
    zones: [{ x: 10, y: 10, width: 50, height: 50 }]
  },
  {
    type: "Hiragana",
    character: "い",
    pronunciation: "",
    meaning: "Hiragana for 'i'",
    romaji: "i",
    strokes: 2,
    zones: [{ x: 15, y: 15, width: 55, height: 55 }]
  },
  {
    type: "Hiragana",
    character: "う",
    pronunciation: "",
    meaning: "Hiragana for 'u'",
    romaji: "u",
    strokes: 2,
    zones: [{ x: 20, y: 20, width: 60, height: 60 }]
  },
  {
    type: "Hiragana",
    character: "え",
    pronunciation: "",
    meaning: "Hiragana for 'e'",
    romaji: "e",
    strokes: 2,
    zones: [{ x: 25, y: 25, width: 65, height: 65 }]
  },
  {
    type: "Hiragana",
    character: "お",
    pronunciation: "",
    meaning: "Hiragana for 'o'",
    romaji: "o",
    strokes: 3,
    zones: [{ x: 30, y: 30, width: 70, height: 70 }]
  },
  {
    type: "Hiragana",
    character: "か",
    pronunciation: "",
    meaning: "Hiragana for 'ka'",
    romaji: "ka",
    strokes: 3,
    zones: [{ x: 35, y: 35, width: 75, height: 75 }]
  },
  {
    type: "Hiragana",
    character: "き",
    pronunciation: "",
    meaning: "Hiragana for 'ki'",
    romaji: "ki",
    strokes: 3,
    zones: [{ x: 40, y: 40, width: 80, height: 80 }]
  },
  {
    type: "Hiragana",
    character: "く",
    pronunciation: "",
    meaning: "Hiragana for 'ku'",
    romaji: "ku",
    strokes: 2,
    zones: [{ x: 45, y: 45, width: 85, height: 85 }]
  },
  {
    type: "Hiragana",
    character: "け",
    pronunciation: "",
    meaning: "Hiragana for 'ke'",
    romaji: "ke",
    strokes: 3,
    zones: [{ x: 50, y: 50, width: 90, height: 90 }]
  },
  {
    type: "Hiragana",
    character: "こ",
    pronunciation: "",
    meaning: "Hiragana for 'ko'",
    romaji: "ko",
    strokes: 2,
    zones: [{ x: 55, y: 55, width: 95, height: 95 }]
  },
  {
    type: "Hiragana",
    character: "さ",
    pronunciation: "",
    meaning: "Hiragana for 'sa'",
    romaji: "sa",
    strokes: 3,
    zones: [{ x: 60, y: 60, width: 100, height: 100 }]
  },
  {
    type: "Hiragana",
    character: "し",
    pronunciation: "",
    meaning: "Hiragana for 'shi'",
    romaji: "shi",
    strokes: 3,
    zones: [{ x: 65, y: 65, width: 105, height: 105 }]
  },
  {
    type: "Hiragana",
    character: "す",
    pronunciation: "",
    meaning: "Hiragana for 'su'",
    romaji: "su",
    strokes: 2,
    zones: [{ x: 70, y: 70, width: 110, height: 110 }]
  },
  {
    type: "Hiragana",
    character: "せ",
    pronunciation: "",
    meaning: "Hiragana for 'se'",
    romaji: "se",
    strokes: 3,
    zones: [{ x: 75, y: 75, width: 115, height: 115 }]
  },
  {
    type: "Hiragana",
    character: "そ",
    pronunciation: "",
    meaning: "Hiragana for 'so'",
    romaji: "so",
    strokes: 3,
    zones: [{ x: 80, y: 80, width: 120, height: 120 }]
  },
  {
    type: "Hiragana",
    character: "た",
    pronunciation: "",
    meaning: "Hiragana for 'ta'",
    romaji: "ta",
    strokes: 4,
    zones: [{ x: 85, y: 85, width: 125, height: 125 }]
  },
  {
    type: "Hiragana",
    character: "ち",
    pronunciation: "",
    meaning: "Hiragana for 'chi'",
    romaji: "chi",
    strokes: 3,
    zones: [{ x: 90, y: 90, width: 130, height: 130 }]
  },
  {
    type: "Hiragana",
    character: "つ",
    pronunciation: "",
    meaning: "Hiragana for 'tsu'",
    romaji: "tsu",
    strokes: 3,
    zones: [{ x: 95, y: 95, width: 135, height: 135 }]
  },
  {
    type: "Hiragana",
    character: "て",
    pronunciation: "",
    meaning: "Hiragana for 'te'",
    romaji: "te",
    strokes: 3,
    zones: [{ x: 100, y: 100, width: 140, height: 140 }]
  },
  {
    type: "Hiragana",
    character: "と",
    pronunciation: "",
    meaning: "Hiragana for 'to'",
    romaji: "to",
    strokes: 3,
    zones: [{ x: 105, y: 105, width: 145, height: 145 }]
  },
  {
    type: "Hiragana",
    character: "な",
    pronunciation: "",
    meaning: "Hiragana for 'na'",
    romaji: "na",
    strokes: 4,
    zones: [{ x: 110, y: 110, width: 150, height: 150 }]
  },
  {
    type: "Hiragana",
    character: "に",
    pronunciation: "",
    meaning: "Hiragana for 'ni'",
    romaji: "ni",
    strokes: 3,
    zones: [{ x: 115, y: 115, width: 155, height: 155 }]
  },
  {
    type: "Hiragana",
    character: "ぬ",
    pronunciation: "",
    meaning: "Hiragana for 'nu'",
    romaji: "nu",
    strokes: 4,
    zones: [{ x: 120, y: 120, width: 160, height: 160 }]
  },
  {
    type: "Hiragana",
    character: "ね",
    pronunciation: "",
    meaning: "Hiragana for 'ne'",
    romaji: "ne",
    strokes: 4,
    zones: [{ x: 125, y: 125, width: 165, height: 165 }]
  },
  {
    type: "Hiragana",
    character: "の",
    pronunciation: "",
    meaning: "Hiragana for 'no'",
    romaji: "no",
    strokes: 4,
    zones: [{ x: 130, y: 130, width: 170, height: 170 }]
  },
  {
    type: "Hiragana",
    character: "は",
    pronunciation: "",
    meaning: "Hiragana for 'ha'",
    romaji: "ha",
    strokes: 3,
    zones: [{ x: 135, y: 135, width: 175, height: 175 }]
  },
  {
    type: "Hiragana",
    character: "ひ",
    pronunciation: "",
    meaning: "Hiragana for 'hi'",
    romaji: "hi",
    strokes: 3,
    zones: [{ x: 140, y: 140, width: 180, height: 180 }]
  },
  {
    type: "Hiragana",
    character: "ふ",
    pronunciation: "",
    meaning: "Hiragana for 'fu'",
    romaji: "fu",
    strokes: 4,
    zones: [{ x: 145, y: 145, width: 185, height: 185 }]
  },
  {
    type: "Hiragana",
    character: "へ",
    pronunciation: "",
    meaning: "Hiragana for 'he'",
    romaji: "he",
    strokes: 3,
    zones: [{ x: 150, y: 150, width: 190, height: 190 }]
  },
  {
    type: "Hiragana",
    character: "ほ",
    pronunciation: "",
    meaning: "Hiragana for 'ho'",
    romaji: "ho",
    strokes: 5,
    zones: [{ x: 155, y: 155, width: 195, height: 195 }]
  },
  {
    type: "Hiragana",
    character: "ま",
    pronunciation: "",
    meaning: "Hiragana for 'ma'",
    romaji: "ma",
    strokes: 3,
    zones: [{ x: 160, y: 160, width: 200, height: 200 }]
  },
  {
    type: "Hiragana",
    character: "み",
    pronunciation: "",
    meaning: "Hiragana for 'mi'",
    romaji: "mi",
    strokes: 3,
    zones: [{ x: 165, y: 165, width: 205, height: 205 }]
  },
  {
    type: "Hiragana",
    character: "む",
    pronunciation: "",
    meaning: "Hiragana for 'mu'",
    romaji: "mu",
    strokes: 3,
    zones: [{ x: 170, y: 170, width: 210, height: 210 }]
  },
  {
    type: "Hiragana",
    character: "め",
    pronunciation: "",
    meaning: "Hiragana for 'me'",
    romaji: "me",
    strokes: 3,
    zones: [{ x: 175, y: 175, width: 215, height: 215 }]
  },
  {
    type: "Hiragana",
    character: "も",
    pronunciation: "",
    meaning: "Hiragana for 'mo'",
    romaji: "mo",
    strokes: 3,
    zones: [{ x: 180, y: 180, width: 220, height: 220 }]
  },
  {
    type: "Hiragana",
    character: "や",
    pronunciation: "",
    meaning: "Hiragana for 'ya'",
    romaji: "ya",
    strokes: 3,
    zones: [{ x: 185, y: 185, width: 225, height: 225 }]
  },
  {
    type: "Hiragana",
    character: "ゆ",
    pronunciation: "",
    meaning: "Hiragana for 'yu'",
    romaji: "yu",
    strokes: 3,
    zones: [{ x: 190, y: 190, width: 230, height: 230 }]
  },
  {
    type: "Hiragana",
    character: "よ",
    pronunciation: "",
    meaning: "Hiragana for 'yo'",
    romaji: "yo",
    strokes: 3,
    zones: [{ x: 195, y: 195, width: 235, height: 235 }]
  },
  {
    type: "Hiragana",
    character: "ら",
    pronunciation: "",
    meaning: "Hiragana for 'ra'",
    romaji: "ra",
    strokes: 2,
    zones: [{ x: 200, y: 200, width: 240, height: 240 }]
  },
  {
    type: "Hiragana",
    character: "り",
    pronunciation: "",
    meaning: "Hiragana for 'ri'",
    romaji: "ri",
    strokes: 2,
    zones: [{ x: 205, y: 205, width: 245, height: 245 }]
  },
  {
    type: "Hiragana",
    character: "る",
    pronunciation: "",
    meaning: "Hiragana for 'ru'",
    romaji: "ru",
    strokes: 2,
    zones: [{ x: 210, y: 210, width: 250, height: 250 }]
  },
  {
    type: "Hiragana",
    character: "れ",
    pronunciation: "",
    meaning: "Hiragana for 're'",
    romaji: "re",
    strokes: 2,
    zones: [{ x: 215, y: 215, width: 255, height: 255 }]
  },
  {
    type: "Hiragana",
    character: "ろ",
    pronunciation: "",
    meaning: "Hiragana for 'ro'",
    romaji: "ro",
    strokes: 2,
    zones: [{ x: 220, y: 220, width: 260, height: 260 }]
  },
  {
    type: "Hiragana",
    character: "わ",
    pronunciation: "",
    meaning: "Hiragana for 'wa'",
    romaji: "wa",
    strokes: 2,
    zones: [{ x: 225, y: 225, width: 265, height: 265 }]
  },
  {
    type: "Hiragana",
    character: "を",
    pronunciation: "",
    meaning: "Hiragana for 'wo'",
    romaji: "wo",
    strokes: 3,
    zones: [{ x: 230, y: 230, width: 270, height: 270 }]
  },
  {
    type: "Hiragana",
    character: "ん",
    pronunciation: "",
    meaning: "Hiragana for 'n'",
    romaji: "n",
    strokes: 2,
    zones: [{ x: 235, y: 235, width: 275, height: 275 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "が",
    pronunciation: "",
    meaning: "Hiragana for 'ga'",
    romaji: "ga",
    strokes: 3,
    zones: [{ x: 260, y: 260, width: 300, height: 300 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぎ",
    pronunciation: "",
    meaning: "Hiragana for 'gi'",
    romaji: "gi",
    strokes: 3,
    zones: [{ x: 265, y: 265, width: 305, height: 305 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぐ",
    pronunciation: "",
    meaning: "Hiragana for 'gu'",
    romaji: "gu",
    strokes: 3,
    zones: [{ x: 270, y: 270, width: 310, height: 310 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "げ",
    pronunciation: "",
    meaning: "Hiragana for 'ge'",
    romaji: "ge",
    strokes: 3,
    zones: [{ x: 275, y: 275, width: 315, height: 315 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ご",
    pronunciation: "",
    meaning: "Hiragana for 'go'",
    romaji: "go",
    strokes: 3,
    zones: [{ x: 280, y: 280, width: 320, height: 320 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ざ",
    pronunciation: "",
    meaning: "Hiragana for 'za'",
    romaji: "za",
    strokes: 3,
    zones: [{ x: 285, y: 285, width: 325, height: 325 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "じ",
    pronunciation: "",
    meaning: "Hiragana for 'ji'",
    romaji: "ji",
    strokes: 3,
    zones: [{ x: 290, y: 290, width: 330, height: 330 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ず",
    pronunciation: "",
    meaning: "Hiragana for 'zu'",
    romaji: "zu",
    strokes: 3,
    zones: [{ x: 295, y: 295, width: 335, height: 335 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぜ",
    pronunciation: "",
    meaning: "Hiragana for 'ze'",
    romaji: "ze",
    strokes: 3,
    zones: [{ x: 300, y: 300, width: 340, height: 340 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぞ",
    pronunciation: "",
    meaning: "Hiragana for 'zo'",
    romaji: "zo",
    strokes: 3,
    zones: [{ x: 305, y: 305, width: 345, height: 345 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "だ",
    pronunciation: "",
    meaning: "Hiragana for 'da'",
    romaji: "da",
    strokes: 3,
    zones: [{ x: 310, y: 310, width: 350, height: 350 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぢ",
    pronunciation: "",
    meaning: "Hiragana for 'ji'",
    romaji: "ji",
    strokes: 3,
    zones: [{ x: 315, y: 315, width: 355, height: 355 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "づ",
    pronunciation: "",
    meaning: "Hiragana for 'zu'",
    romaji: "zu",
    strokes: 3,
    zones: [{ x: 320, y: 320, width: 360, height: 360 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "で",
    pronunciation: "",
    meaning: "Hiragana for 'de'",
    romaji: "de",
    strokes: 3,
    zones: [{ x: 325, y: 325, width: 365, height: 365 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ど",
    pronunciation: "",
    meaning: "Hiragana for 'do'",
    romaji: "do",
    strokes: 3,
    zones: [{ x: 330, y: 330, width: 370, height: 370 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ば",
    pronunciation: "",
    meaning: "Hiragana for 'ba'",
    romaji: "ba",
    strokes: 3,
    zones: [{ x: 335, y: 335, width: 375, height: 375 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "び",
    pronunciation: "",
    meaning: "Hiragana for 'bi'",
    romaji: "bi",
    strokes: 3,
    zones: [{ x: 340, y: 340, width: 380, height: 380 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぶ",
    pronunciation: "",
    meaning: "Hiragana for 'bu'",
    romaji: "bu",
    strokes: 3,
    zones: [{ x: 345, y: 345, width: 385, height: 385 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "べ",
    pronunciation: "",
    meaning: "Hiragana for 'be'",
    romaji: "be",
    strokes: 3,
    zones: [{ x: 350, y: 350, width: 390, height: 390 }]
  },
  {
    type: "Hiragana-Dakuon",
    character: "ぼ",
    pronunciation: "",
    meaning: "Hiragana for 'bo'",
    romaji: "bo",
    strokes: 3,
    zones: [{ x: 355, y: 355, width: 395, height: 395 }]
  },
  {
    type: "Hiragana-Handakuon",
    character: "ぱ",
    pronunciation: "",
    meaning: "Hiragana for 'pa'",
    romaji: "pa",
    strokes: 3,
    zones: [{ x: 360, y: 360, width: 400, height: 400 }]
  },
  {
    type: "Hiragana-Handakuon",
    character: "ぴ",
    pronunciation: "",
    meaning: "Hiragana for 'pi'",
    romaji: "pi",
    strokes: 3,
    zones: [{ x: 365, y: 365, width: 405, height: 405 }]
  },
  {
    type: "Hiragana-Handakuon",
    character: "ぷ",
    pronunciation: "",
    meaning: "Hiragana for 'pu'",
    romaji: "pu",
    strokes: 3,
    zones: [{ x: 370, y: 370, width: 410, height: 410 }]
  },
  {
    type: "Hiragana-Handakuon",
    character: "ぺ",
    pronunciation: "",
    meaning: "Hiragana for 'pe'",
    romaji: "pe",
    strokes: 3,
    zones: [{ x: 375, y: 375, width: 415, height: 415 }]
  },
  {
    type: "Hiragana-Handakuon",
    character: "ぽ",
    pronunciation: "",
    meaning: "Hiragana for 'po'",
    romaji: "po",
    strokes: 3,
    zones: [{ x: 380, y: 380, width: 420, height: 420 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "きゃ",
    pronunciation: "",
    meaning: "Hiragana for 'kya'",
    romaji: "kya",
    strokes: 4,
    zones: [{ x: 10, y: 10, width: 50, height: 50 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "きゅ",
    pronunciation: "",
    meaning: "Hiragana for 'kyu'",
    romaji: "kyu",
    strokes: 4,
    zones: [{ x: 15, y: 15, width: 55, height: 55 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "きょ",
    pronunciation: "",
    meaning: "Hiragana for 'kyo'",
    romaji: "kyo",
    strokes: 4,
    zones: [{ x: 20, y: 20, width: 60, height: 60 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "しゃ",
    pronunciation: "",
    meaning: "Hiragana for 'sha'",
    romaji: "sha",
    strokes: 4,
    zones: [{ x: 25, y: 25, width: 65, height: 65 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "しゅ",
    pronunciation: "",
    meaning: "Hiragana for 'shu'",
    romaji: "shu",
    strokes: 4,
    zones: [{ x: 30, y: 30, width: 70, height: 70 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "しょ",
    pronunciation: "",
    meaning: "Hiragana for 'sho'",
    romaji: "sho",
    strokes: 4,
    zones: [{ x: 35, y: 35, width: 75, height: 75 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ちゃ",
    pronunciation: "",
    meaning: "Hiragana for 'cha'",
    romaji: "cha",
    strokes: 4,
    zones: [{ x: 40, y: 40, width: 80, height: 80 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ちゅ",
    pronunciation: "",
    meaning: "Hiragana for 'chu'",
    romaji: "chu",
    strokes: 4,
    zones: [{ x: 45, y: 45, width: 85, height: 85 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ちょ",
    pronunciation: "",
    meaning: "Hiragana for 'cho'",
    romaji: "cho",
    strokes: 4,
    zones: [{ x: 50, y: 50, width: 90, height: 90 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "にゃ",
    pronunciation: "",
    meaning: "Hiragana for 'nya'",
    romaji: "nya",
    strokes: 4,
    zones: [{ x: 55, y: 55, width: 95, height: 95 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "にゅ",
    pronunciation: "",
    meaning: "Hiragana for 'nyu'",
    romaji: "nyu",
    strokes: 4,
    zones: [{ x: 60, y: 60, width: 100, height: 100 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "にょ",
    pronunciation: "",
    meaning: "Hiragana for 'nyo'",
    romaji: "nyo",
    strokes: 4,
    zones: [{ x: 65, y: 65, width: 105, height: 105 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ひゃ",
    pronunciation: "",
    meaning: "Hiragana for 'hya'",
    romaji: "hya",
    strokes: 4,
    zones: [{ x: 70, y: 70, width: 110, height: 110 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ひゅ",
    pronunciation: "",
    meaning: "Hiragana for 'hyu'",
    romaji: "hyu",
    strokes: 4,
    zones: [{ x: 75, y: 75, width: 115, height: 115 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ひょ",
    pronunciation: "",
    meaning: "Hiragana for 'hyo'",
    romaji: "hyo",
    strokes: 4,
    zones: [{ x: 80, y: 80, width: 120, height: 120 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "みゃ",
    pronunciation: "",
    meaning: "Hiragana for 'mya'",
    romaji: "mya",
    strokes: 4,
    zones: [{ x: 85, y: 85, width: 125, height: 125 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "みゅ",
    pronunciation: "",
    meaning: "Hiragana for 'myu'",
    romaji: "myu",
    strokes: 4,
    zones: [{ x: 90, y: 90, width: 130, height: 130 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "みょ",
    pronunciation: "",
    meaning: "Hiragana for 'myo'",
    romaji: "myo",
    strokes: 4,
    zones: [{ x: 95, y: 95, width: 135, height: 135 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "りゃ",
    pronunciation: "",
    meaning: "Hiragana for 'rya'",
    romaji: "rya",
    strokes: 4,
    zones: [{ x: 100, y: 100, width: 140, height: 140 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "りゅ",
    pronunciation: "",
    meaning: "Hiragana for 'ryu'",
    romaji: "ryu",
    strokes: 4,
    zones: [{ x: 105, y: 105, width: 145, height: 145 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "りょ",
    pronunciation: "",
    meaning: "Hiragana for 'ryo'",
    romaji: "ryo",
    strokes: 4,
    zones: [{ x: 110, y: 110, width: 150, height: 150 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぎゃ",
    pronunciation: "",
    meaning: "Hiragana for 'gya'",
    romaji: "gya",
    strokes: 4,
    zones: [{ x: 115, y: 115, width: 155, height: 155 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぎゅ",
    pronunciation: "",
    meaning: "Hiragana for 'gyu'",
    romaji: "gyu",
    strokes: 4,
    zones: [{ x: 120, y: 120, width: 160, height: 160 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぎょ",
    pronunciation: "",
    meaning: "Hiragana for 'gyo'",
    romaji: "gyo",
    strokes: 4,
    zones: [{ x: 125, y: 125, width: 165, height: 165 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "じゃ",
    pronunciation: "",
    meaning: "Hiragana for 'ja'",
    romaji: "ja",
    strokes: 4,
    zones: [{ x: 130, y: 130, width: 170, height: 170 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "じゅ",
    pronunciation: "",
    meaning: "Hiragana for 'ju'",
    romaji: "ju",
    strokes: 4,
    zones: [{ x: 135, y: 135, width: 175, height: 175 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "じょ",
    pronunciation: "",
    meaning: "Hiragana for 'jo'",
    romaji: "jo",
    strokes: 4,
    zones: [{ x: 140, y: 140, width: 180, height: 180 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "びゃ",
    pronunciation: "",
    meaning: "Hiragana for 'bya'",
    romaji: "bya",
    strokes: 4,
    zones: [{ x: 145, y: 145, width: 185, height: 185 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "びゅ",
    pronunciation: "",
    meaning: "Hiragana for 'byu'",
    romaji: "byu",
    strokes: 4,
    zones: [{ x: 150, y: 150, width: 190, height: 190 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "びょ",
    pronunciation: "",
    meaning: "Hiragana for 'byo'",
    romaji: "byo",
    strokes: 4,
    zones: [{ x: 155, y: 155, width: 195, height: 195 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぴゃ",
    pronunciation: "",
    meaning: "Hiragana for 'pya'",
    romaji: "pya",
    strokes: 4,
    zones: [{ x: 160, y: 160, width: 200, height: 200 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぴゅ",
    pronunciation: "",
    meaning: "Hiragana for 'pyu'",
    romaji: "pyu",
    strokes: 4,
    zones: [{ x: 165, y: 165, width: 205, height: 205 }]
  },
  {
    type: "Hiragana-Yoon",
    character: "ぴょ",
    pronunciation: "",
    meaning: "Hiragana for 'pyo'",
    romaji: "pyo",
    strokes: 4,
    zones: [{ x: 170, y: 170, width: 210, height: 210 }]
  },
  {
    type: "Katakana",
    character: "ア",
    pronunciation: "",
    meaning: "Katakana for 'a'",
    romaji: "a",
    strokes: 2,
    zones: [{ x: 10, y: 10, width: 50, height: 50 }]
  },
  {
    type: "Katakana",
    character: "イ",
    pronunciation: "",
    meaning: "Katakana for 'i'",
    romaji: "i",
    strokes: 2,
    zones: [{ x: 15, y: 15, width: 55, height: 55 }]
  },
  {
    type: "Katakana",
    character: "ウ",
    pronunciation: "",
    meaning: "Katakana for 'u'",
    romaji: "u",
    strokes: 2,
    zones: [{ x: 20, y: 20, width: 60, height: 60 }]
  },
  {
    type: "Katakana",
    character: "エ",
    pronunciation: "",
    meaning: "Katakana for 'e'",
    romaji: "e",
    strokes: 2,
    zones: [{ x: 25, y: 25, width: 65, height: 65 }]
  },
  {
    type: "Katakana",
    character: "オ",
    pronunciation: "",
    meaning: "Katakana for 'o'",
    romaji: "o",
    strokes: 3,
    zones: [{ x: 30, y: 30, width: 70, height: 70 }]
  },
  {
    type: "Katakana",
    character: "カ",
    pronunciation: "",
    meaning: "Katakana for 'ka'",
    romaji: "ka",
    strokes: 2,
    zones: [{ x: 35, y: 35, width: 75, height: 75 }]
  },
  {
    type: "Katakana",
    character: "キ",
    pronunciation: "",
    meaning: "Katakana for 'ki'",
    romaji: "ki",
    strokes: 3,
    zones: [{ x: 40, y: 40, width: 80, height: 80 }]
  },
  {
    type: "Katakana",
    character: "ク",
    pronunciation: "",
    meaning: "Katakana for 'ku'",
    romaji: "ku",
    strokes: 2,
    zones: [{ x: 45, y: 45, width: 85, height: 85 }]
  },
  {
    type: "Katakana",
    character: "ケ",
    pronunciation: "",
    meaning: "Katakana for 'ke'",
    romaji: "ke",
    strokes: 3,
    zones: [{ x: 50, y: 50, width: 90, height: 90 }]
  },
  {
    type: "Katakana",
    character: "コ",
    pronunciation: "",
    meaning: "Katakana for 'ko'",
    romaji: "ko",
    strokes: 2,
    zones: [{ x: 55, y: 55, width: 95, height: 95 }]
  },
  {
  type: "Katakana",
  character: "サ",
  pronunciation: "",
  meaning: "Katakana for 'sa'",
  romaji: "sa",
  strokes: 3,
  zones: [{ x: 60, y: 60, width: 100, height: 100 }]
},
{
  type: "Katakana",
  character: "シ",
  pronunciation: "",
  meaning: "Katakana for 'shi'",
  romaji: "shi",
  strokes: 3,
  zones: [{ x: 65, y: 65, width: 105, height: 105 }]
},
{
  type: "Katakana",
  character: "ス",
  pronunciation: "",
  meaning: "Katakana for 'su'",
  romaji: "su",
  strokes: 2,
  zones: [{ x: 70, y: 70, width: 110, height: 110 }]
},
{
  type: "Katakana",
  character: "セ",
  pronunciation: "",
  meaning: "Katakana for 'se'",
  romaji: "se",
  strokes: 3,
  zones: [{ x: 75, y: 75, width: 115, height: 115 }]
},
{
  type: "Katakana",
  character: "ソ",
  pronunciation: "",
  meaning: "Katakana for 'so'",
  romaji: "so",
  strokes: 2,
  zones: [{ x: 80, y: 80, width: 120, height: 120 }]
},
{
  type: "Katakana",
  character: "タ",
  pronunciation: "",
  meaning: "Katakana for 'ta'",
  romaji: "ta",
  strokes: 3,
  zones: [{ x: 85, y: 85, width: 125, height: 125 }]
},
{
  type: "Katakana",
  character: "チ",
  pronunciation: "",
  meaning: "Katakana for 'chi'",
  romaji: "chi",
  strokes: 3,
  zones: [{ x: 90, y: 90, width: 130, height: 130 }]
},
{
  type: "Katakana",
  character: "ツ",
  pronunciation: "",
  meaning: "Katakana for 'tsu'",
  romaji: "tsu",
  strokes: 3,
  zones: [{ x: 95, y: 95, width: 135, height: 135 }]
},
{
  type: "Katakana",
  character: "テ",
  pronunciation: "",
  meaning: "Katakana for 'te'",
  romaji: "te",
  strokes: 3,
  zones: [{ x: 100, y: 100, width: 140, height: 140 }]
},
{
  type: "Katakana",
  character: "ト",
  pronunciation: "",
  meaning: "Katakana for 'to'",
  romaji: "to",
  strokes: 2,
  zones: [{ x: 105, y: 105, width: 145, height: 145 }]
},
{
  type: "Katakana",
  character: "ナ",
  pronunciation: "",
  meaning: "Katakana for 'na'",
  romaji: "na",
  strokes: 2,
  zones: [{ x: 110, y: 110, width: 150, height: 150 }]
},
{
  type: "Katakana",
  character: "ニ",
  pronunciation: "",
  meaning: "Katakana for 'ni'",
  romaji: "ni",
  strokes: 2,
  zones: [{ x: 115, y: 115, width: 155, height: 155 }]
},
{
  type: "Katakana",
  character: "ヌ",
  pronunciation: "",
  meaning: "Katakana for 'nu'",
  romaji: "nu",
  strokes: 2,
  zones: [{ x: 120, y: 120, width: 160, height: 160 }]
},
{
  type: "Katakana",
  character: "ネ",
  pronunciation: "",
  meaning: "Katakana for 'ne'",
  romaji: "ne",
  strokes: 2,
  zones: [{ x: 125, y: 125, width: 165, height: 165 }]
},
{
  type: "Katakana",
  character: "ノ",
  pronunciation: "",
  meaning: "Katakana for 'no'",
  romaji: "no",
  strokes: 2,
  zones: [{ x: 130, y: 130, width: 170, height: 170 }]
},
{
  type: "Katakana",
  character: "ハ",
  pronunciation: "",
  meaning: "Katakana for 'ha'",
  romaji: "ha",
  strokes: 2,
  zones: [{ x: 135, y: 135, width: 175, height: 175 }]
},
{
  type: "Katakana",
  character: "ヒ",
  pronunciation: "",
  meaning: "Katakana for 'hi'",
  romaji: "hi",
  strokes: 2,
  zones: [{ x: 140, y: 140, width: 180, height: 180 }]
},
{
  type: "Katakana",
  character: "フ",
  pronunciation: "",
  meaning: "Katakana for 'fu'",
  romaji: "fu",
  strokes: 2,
  zones: [{ x: 145, y: 145, width: 185, height: 185 }]
},
{
  type: "Katakana",
  character: "ヘ",
  pronunciation: "",
  meaning: "Katakana for 'he'",
  romaji: "he",
  strokes: 2,
  zones: [{ x: 150, y: 150, width: 190, height: 190 }]
},
{
  type: "Katakana",
  character: "ホ",
  pronunciation: "",
  meaning: "Katakana for 'ho'",
  romaji: "ho",
  strokes: 2,
  zones: [{ x: 155, y: 155, width: 195, height: 195 }]
},
{
  type: "Katakana",
  character: "マ",
  pronunciation: "",
  meaning: "Katakana for 'ma'",
  romaji: "ma",
  strokes: 2,
  zones: [{ x: 160, y: 160, width: 200, height: 200 }]
},
{
  type: "Katakana",
  character: "ミ",
  pronunciation: "",
  meaning: "Katakana for 'mi'",
  romaji: "mi",
  strokes: 2,
  zones: [{ x: 165, y: 165, width: 205, height: 205 }]
},
{
  type: "Katakana",
  character: "ム",
  pronunciation: "",
  meaning: "Katakana for 'mu'",
  romaji: "mu",
  strokes: 2,
  zones: [{ x: 170, y: 170, width: 210, height: 210 }]
},
{
  type: "Katakana",
  character: "メ",
  pronunciation: "",
  meaning: "Katakana for 'me'",
  romaji: "me",
  strokes: 2,
  zones: [{ x: 175, y: 175, width: 215, height: 215 }]
},
{
  type: "Katakana",
  character: "モ",
  pronunciation: "",
  meaning: "Katakana for 'mo'",
  romaji: "mo",
  strokes: 2,
  zones: [{ x: 180, y: 180, width: 220, height: 220 }]
},
{
  type: "Katakana",
  character: "ヤ",
  pronunciation: "",
  meaning: "Katakana for 'ya'",
  romaji: "ya",
  strokes: 2,
  zones: [{ x: 185, y: 185, width: 225, height: 225 }]
},
{
  type: "Katakana",
  character: "ユ",
  pronunciation: "",
  meaning: "Katakana for 'yu'",
  romaji: "yu",
  strokes: 2,
  zones: [{ x: 190, y: 190, width: 230, height: 230 }]
},
{
  type: "Katakana",
  character: "ヨ",
  pronunciation: "",
  meaning: "Katakana for 'yo'",
  romaji: "yo",
  strokes: 2,
  zones: [{ x: 195, y: 195, width: 235, height: 235 }]
},
{
  type: "Katakana",
  character: "ラ",
  pronunciation: "",
  meaning: "Katakana for 'ra'",
  romaji: "ra",
  strokes: 2,
  zones: [{ x: 200, y: 200, width: 240, height: 240 }]
},
{
  type: "Katakana",
  character: "リ",
  pronunciation: "",
  meaning: "Katakana for 'ri'",
  romaji: "ri",
  strokes: 2,
  zones: [{ x: 205, y: 205, width: 245, height: 245 }]
},
{
  type: "Katakana",
  character: "ル",
  pronunciation: "",
  meaning: "Katakana for 'ru'",
  romaji: "ru",
  strokes: 2,
  zones: [{ x: 210, y: 210, width: 250, height: 250 }]
},
{
  type: "Katakana",
  character: "レ",
  pronunciation: "",
  meaning: "Katakana for 're'",
  romaji: "re",
  strokes: 2,
  zones: [{ x: 215, y: 215, width: 255, height: 255 }]
},
{
  type: "Katakana",
  character: "ロ",
  pronunciation: "",
  meaning: "Katakana for 'ro'",
  romaji: "ro",
  strokes: 2,
  zones: [{ x: 220, y: 220, width: 260, height: 260 }]
},
{
  type: "Katakana",
  character: "ワ",
  pronunciation: "",
  meaning: "Katakana for 'wa'",
  romaji: "wa",
  strokes: 2,
  zones: [{ x: 225, y: 225, width: 265, height: 265 }]
},
{
  type: "Katakana",
  character: "ヲ",
  pronunciation: "",
  meaning: "Katakana for 'wo'",
  romaji: "wo",
  strokes: 2,
  zones: [{ x: 230, y: 230, width: 270, height: 270 }]
},
{
  type: "Katakana",
  character: "ン",
  pronunciation: "",
  meaning: "Katakana for 'n'",
  romaji: "n",
  strokes: 2,
  zones: [{ x: 235, y: 235, width: 275, height: 275 }]
},
{
  type: "Katakana-Dakuon",
  character: "ガ",
  pronunciation: "",
  meaning: "Katakana for 'ga'",
  romaji: "ga",
  strokes: 3,
  zones: [{ x: 10, y: 10, width: 50, height: 50 }]
},
{
  type: "Katakana-Dakuon",
  character: "ギ",
  pronunciation: "",
  meaning: "Katakana for 'gi'",
  romaji: "gi",
  strokes: 3,
  zones: [{ x: 15, y: 15, width: 55, height: 55 }]
},
{
  type: "Katakana-Dakuon",
  character: "グ",
  pronunciation: "",
  meaning: "Katakana for 'gu'",
  romaji: "gu",
  strokes: 3,
  zones: [{ x: 20, y: 20, width: 60, height: 60 }]
},
{
  type: "Katakana-Dakuon",
  character: "ゲ",
  pronunciation: "",
  meaning: "Katakana for 'ge'",
  romaji: "ge",
  strokes: 3,
  zones: [{ x: 25, y: 25, width: 65, height: 65 }]
},
{
  type: "Katakana-Dakuon",
  character: "ゴ",
  pronunciation: "",
  meaning: "Katakana for 'go'",
  romaji: "go",
  strokes: 3,
  zones: [{ x: 30, y: 30, width: 70, height: 70 }]
},
{
  type: "Katakana-Dakuon",
  character: "ザ",
  pronunciation: "",
  meaning: "Katakana for 'za'",
  romaji: "za",
  strokes: 3,
  zones: [{ x: 35, y: 35, width: 75, height: 75 }]
},
{
  type: "Katakana-Dakuon",
  character: "ジ",
  pronunciation: "",
  meaning: "Katakana for 'ji'",
  romaji: "ji",
  strokes: 3,
  zones: [{ x: 40, y: 40, width: 80, height: 80 }]
},
{
  type: "Katakana-Dakuon",
  character: "ズ",
  pronunciation: "",
  meaning: "Katakana for 'zu'",
  romaji: "zu",
  strokes: 3,
  zones: [{ x: 45, y: 45, width: 85, height: 85 }]
},
{
  type: "Katakana-Dakuon",
  character: "ゼ",
  pronunciation: "",
  meaning: "Katakana for 'ze'",
  romaji: "ze",
  strokes: 3,
  zones: [{ x: 50, y: 50, width: 90, height: 90 }]
},
{
  type: "Katakana-Dakuon",
  character: "ゾ",
  pronunciation: "",
  meaning: "Katakana for 'zo'",
  romaji: "zo",
  strokes: 3,
  zones: [{ x: 55, y: 55, width: 95, height: 95 }]
},
{
  type: "Katakana-Dakuon",
  character: "ダ",
  pronunciation: "",
  meaning: "Katakana for 'da'",
  romaji: "da",
  strokes: 3,
  zones: [{ x: 60, y: 60, width: 100, height: 100 }]
},
{
  type: "Katakana-Dakuon",
  character: "ヂ",
  pronunciation: "",
  meaning: "Katakana for 'ji'",
  romaji: "ji",
  strokes: 3,
  zones: [{ x: 65, y: 65, width: 105, height: 105 }]
},
{
  type: "Katakana-Dakuon",
  character: "ヅ",
  pronunciation: "",
  meaning: "Katakana for 'zu'",
  romaji: "zu",
  strokes: 3,
  zones: [{ x: 70, y: 70, width: 110, height: 110 }]
},
{
  type: "Katakana-Dakuon",
  character: "デ",
  pronunciation: "",
  meaning: "Katakana for 'de'",
  romaji: "de",
  strokes: 3,
  zones: [{ x: 75, y: 75, width: 115, height: 115 }]
},
{
  type: "Katakana-Dakuon",
  character: "ド",
  pronunciation: "",
  meaning: "Katakana for 'do'",
  romaji: "do",
  strokes: 3,
  zones: [{ x: 80, y: 80, width: 120, height: 120 }]
},
{
  type: "Katakana-Dakuon",
  character: "バ",
  pronunciation: "",
  meaning: "Katakana for 'ba'",
  romaji: "ba",
  strokes: 3,
  zones: [{ x: 85, y: 85, width: 125, height: 125 }]
},
{
  type: "Katakana-Dakuon",
  character: "ビ",
  pronunciation: "",
  meaning: "Katakana for 'bi'",
  romaji: "bi",
  strokes: 3,
  zones: [{ x: 90, y: 90, width: 130, height: 130 }]
},
{
  type: "Katakana-Dakuon",
  character: "ブ",
  pronunciation: "",
  meaning: "Katakana for 'bu'",
  romaji: "bu",
  strokes: 3,
  zones: [{ x: 95, y: 95, width: 135, height: 135 }]
},
{
  type: "Katakana-Dakuon",
  character: "ベ",
  pronunciation: "",
  meaning: "Katakana for 'be'",
  romaji: "be",
  strokes: 3,
  zones: [{ x: 100, y: 100, width: 140, height: 140 }]
},
{
  type: "Katakana-Dakuon",
  character: "ボ",
  pronunciation: "",
  meaning: "Katakana for 'bo'",
  romaji: "bo",
  strokes: 3,
  zones: [{ x: 105, y: 105, width: 145, height: 145 }]
},
{
  type: "Katakana-Handakuon",
  character: "パ",
  pronunciation: "",
  meaning: "Katakana for 'pa'",
  romaji: "pa",
  strokes: 3,
  zones: [{ x: 10, y: 10, width: 50, height: 50 }]
},
{
  type: "Katakana-Handakuon",
  character: "ピ",
  pronunciation: "",
  meaning: "Katakana for 'pi'",
  romaji: "pi",
  strokes: 3,
  zones: [{ x: 15, y: 15, width: 55, height: 55 }]
},
{
  type: "Katakana-Handakuon",
  character: "プ",
  pronunciation: "",
  meaning: "Katakana for 'pu'",
  romaji: "pu",
  strokes: 3,
  zones: [{ x: 20, y: 20, width: 60, height: 60 }]
},
{
  type: "Katakana-Handakuon",
  character: "ペ",
  pronunciation: "",
  meaning: "Katakana for 'pe'",
  romaji: "pe",
  strokes: 3,
  zones: [{ x: 25, y: 25, width: 65, height: 65 }]
},
{
  type: "Katakana-Handakuon",
  character: "ポ",
  pronunciation: "",
  meaning: "Katakana for 'po'",
  romaji: "po",
  strokes: 3,
  zones: [{ x: 30, y: 30, width: 70, height: 70 }]
},
{
  type: "Katakana-Yoon",
  character: "キャ",
  pronunciation: "",
  meaning: "Katakana for 'kya'",
  romaji: "kya",
  strokes: 3,
  zones: [{ x: 10, y: 10, width: 50, height: 50 }]
},
{
  type: "Katakana-Yoon",
  character: "キュ",
  pronunciation: "",
  meaning: "Katakana for 'kyu'",
  romaji: "kyu",
  strokes: 3,
  zones: [{ x: 15, y: 15, width: 55, height: 55 }]
},
{
  type: "Katakana-Yoon",
  character: "キョ",
  pronunciation: "",
  meaning: "Katakana for 'kyo'",
  romaji: "kyo",
  strokes: 3,
  zones: [{ x: 20, y: 20, width: 60, height: 60 }]
},
{
  type: "Katakana-Yoon",
  character: "シャ",
  pronunciation: "",
  meaning: "Katakana for 'sha'",
  romaji: "sha",
  strokes: 3,
  zones: [{ x: 25, y: 25, width: 65, height: 65 }]
},
{
  type: "Katakana-Yoon",
  character: "シュ",
  pronunciation: "",
  meaning: "Katakana for 'shu'",
  romaji: "shu",
  strokes: 3,
  zones: [{ x: 30, y: 30, width: 70, height: 70 }]
},
{
  type: "Katakana-Yoon",
  character: "ショ",
  pronunciation: "",
  meaning: "Katakana for 'sho'",
  romaji: "sho",
  strokes: 3,
  zones: [{ x: 35, y: 35, width: 75, height: 75 }]
},
{
  type: "Katakana-Yoon",
  character: "チャ",
  pronunciation: "",
  meaning: "Katakana for 'cha'",
  romaji: "cha",
  strokes: 3,
  zones: [{ x: 40, y: 40, width: 80, height: 80 }]
},
{
  type: "Katakana-Yoon",
  character: "チュ",
  pronunciation: "",
  meaning: "Katakana for 'chu'",
  romaji: "chu",
  strokes: 3,
  zones: [{ x: 45, y: 45, width: 85, height: 85 }]
},
{
  type: "Katakana-Yoon",
  character: "チョ",
  pronunciation: "",
  meaning: "Katakana for 'cho'",
  romaji: "cho",
  strokes: 3,
  zones: [{ x: 50, y: 50, width: 90, height: 90 }]
},
{
  type: "Katakana-Yoon",
  character: "ニャ",
  pronunciation: "",
  meaning: "Katakana for 'nya'",
  romaji: "nya",
  strokes: 3,
  zones: [{ x: 55, y: 55, width: 95, height: 95 }]
},
{
  type: "Katakana-Yoon",
  character: "ニュ",
  pronunciation: "",
  meaning: "Katakana for 'nyu'",
  romaji: "nyu",
  strokes: 3,
  zones: [{ x: 60, y: 60, width: 100, height: 100 }]
},
{
  type: "Katakana-Yoon",
  character: "ニョ",
  pronunciation: "",
  meaning: "Katakana for 'nyo'",
  romaji: "nyo",
  strokes: 3,
  zones: [{ x: 65, y: 65, width: 105, height: 105 }]
},
{
  type: "Katakana-Yoon",
  character: "ヒャ",
  pronunciation: "",
  meaning: "Katakana for 'hya'",
  romaji: "hya",
  strokes: 3,
  zones: [{ x: 70, y: 70, width: 110, height: 110 }]
},
{
  type: "Katakana-Yoon",
  character: "ヒュ",
  pronunciation: "",
  meaning: "Katakana for 'hyu'",
  romaji: "hyu",
  strokes: 3,
  zones: [{ x: 75, y: 75, width: 115, height: 115 }]
},
{
  type: "Katakana-Yoon",
  character: "ヒョ",
  pronunciation: "",
  meaning: "Katakana for 'hyo'",
  romaji: "hyo",
  strokes: 3,
  zones: [{ x: 80, y: 80, width: 120, height: 120 }]
},
{
  type: "Katakana-Yoon",
  character: "ミャ",
  pronunciation: "",
  meaning: "Katakana for 'mya'",
  romaji: "mya",
  strokes: 3,
  zones: [{ x: 85, y: 85, width: 125, height: 125 }]
},
{
  type: "Katakana-Yoon",
  character: "ミュ",
  pronunciation: "",
  meaning: "Katakana for 'myu'",
  romaji: "myu",
  strokes: 3,
  zones: [{ x: 90, y: 90, width: 130, height: 130 }]
},
{
  type: "Katakana-Yoon",
  character: "ミョ",
  pronunciation: "",
  meaning: "Katakana for 'myo'",
  romaji: "myo",
  strokes: 3,
  zones: [{ x: 95, y: 95, width: 135, height: 135 }]
},
{
  type: "Katakana-Yoon",
  character: "リャ",
  pronunciation: "",
  meaning: "Katakana for 'rya'",
  romaji: "rya",
  strokes: 3,
  zones: [{ x: 100, y: 100, width: 140, height: 140 }]
},
{
  type: "Katakana-Yoon",
  character: "リュ",
  pronunciation: "",
  meaning: "Katakana for 'ryu'",
  romaji: "ryu",
  strokes: 3,
  zones: [{ x: 105, y: 105, width: 145, height: 145 }]
},
{
  type: "Katakana-Yoon",
  character: "リョ",
  pronunciation: "",
  meaning: "Katakana for 'ryo'",
  romaji: "ryo",
  strokes: 3,
  zones: [{ x: 110, y: 110, width: 150, height: 150 }]
},
{
  type: "Katakana-Yoon",
  character: "ギャ",
  pronunciation: "",
  meaning: "Katakana for 'gya'",
  romaji: "gya",
  strokes: 3,
  zones: [{ x: 115, y: 115, width: 155, height: 155 }]
},
{
  type: "Katakana-Yoon",
  character: "ギュ",
  pronunciation: "",
  meaning: "Katakana for 'gyu'",
  romaji: "gyu",
  strokes: 3,
  zones: [{ x: 120, y: 120, width: 160, height: 160 }]
},
{
  type: "Katakana-Yoon",
  character: "ギョ",
  pronunciation: "",
  meaning: "Katakana for 'gyo'",
  romaji: "gyo",
  strokes: 3,
  zones: [{ x: 125, y: 125, width: 165, height: 165 }]
},
{
  type: "Katakana-Yoon",
  character: "ジャ",
  pronunciation: "",
  meaning: "Katakana for 'ja'",
  romaji: "ja",
  strokes: 3,
  zones: [{ x: 130, y: 130, width: 170, height: 170 }]
},
{
  type: "Katakana-Yoon",
  character: "ジュ",
  pronunciation: "",
  meaning: "Katakana for 'ju'",
  romaji: "ju",
  strokes: 3,
  zones: [{ x: 135, y: 135, width: 175, height: 175 }]
},
{
  type: "Katakana-Yoon",
  character: "ジョ",
  pronunciation: "",
  meaning: "Katakana for 'jo'",
  romaji: "jo",
  strokes: 3,
  zones: [{ x: 140, y: 140, width: 180, height: 180 }]
},
{
  type: "Katakana-Yoon",
  character: "ビャ",
  pronunciation: "",
  meaning: "Katakana for 'bya'",
  romaji: "bya",
  strokes: 3,
  zones: [{ x: 145, y: 145, width: 185, height: 185 }]
},
{
  type: "Katakana-Yoon",
  character: "ビュ",
  pronunciation: "",
  meaning: "Katakana for 'byu'",
  romaji: "byu",
  strokes: 3,
  zones: [{ x: 150, y: 150, width: 190, height: 190 }]
},
{
  type: "Katakana-Yoon",
  character: "ビョ",
  pronunciation: "",
  meaning: "Katakana for 'byo'",
  romaji: "byo",
  strokes: 3,
  zones: [{ x: 155, y: 155, width: 195, height: 195 }]
},
{
  type: "Katakana-Yoon",
  character: "ピャ",
  pronunciation: "",
  meaning: "Katakana for 'pya'",
  romaji: "pya",
  strokes: 3,
  zones: [{ x: 160, y: 160, width: 200, height: 200 }]
},
{
  type: "Katakana-Yoon",
  character: "ピュ",
  pronunciation: "",
  meaning: "Katakana for 'pyu'",
  romaji: "pyu",
  strokes: 3,
  zones: [{ x: 165, y: 165, width: 205, height: 205 }]
},
{
  type: "Katakana-Yoon",
  character: "ピョ",
  pronunciation: "",
  meaning: "Katakana for 'pyo'",
  romaji: "pyo",
  strokes: 3,
  zones: [{ x: 170, y: 170, width: 210, height: 210 }]
}  
];

export default hiraganaKatakanaData;
